import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getTransactions } from 'services/api/payments'

import { fetchError, fetchSuccess } from './actions'
import { FETCH_NEXT_TRANSACTIONS_PAGE, FETCH_TRANSACTIONS } from './actionTypes'
import { getNextPageUrl } from './selectors'
import { TransactionType } from './types'

const ROW_COUNT = 100

const getUrl = (type: TransactionType) =>
  `payments/transactions?type=${type}&product=MERCURY&limit=${ROW_COUNT}`

const fetch = function* (action) {
  const { type } = action.payload
  const data = yield call(getTransactions, getUrl(type))

  if (!data.ok) return yield put(fetchError(type, data.error))

  yield put(fetchSuccess(type, data.response))
}

const fetchNextPage = function* (action) {
  const { type } = action.payload
  const nextUrl = yield select(getNextPageUrl, type) ?? getUrl(type)
  const data = yield call(getTransactions, nextUrl)

  if (!data.ok) return yield put(fetchError(type, data.error))

  yield put(fetchSuccess(type, data.response))
}

export default function* paymentsChannel() {
  yield takeEvery(FETCH_TRANSACTIONS, fetch)
  yield takeEvery(FETCH_NEXT_TRANSACTIONS_PAGE, fetchNextPage)
}
